import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "returnMonthsContainer",
    "returnTimeSelect",
    "reasonForReturnContainer",
    "returnMonthsField",
    "patientId",
    "returnSelectDiv",
    "indicationContainer"
  ]

  connect() {
    this.showMonthsInput()
    this.showReasonForReturn()
    this.changeReturnTimeDivSize()
  }

  showMonthsInput() {
    if (this.returnTimeSelectTarget.value === "Outro") {
      this.returnMonthsContainerTarget.classList.remove("hidden")
      this.returnMonthsFieldTarget.setAttribute("required", "required")
    } else {
      this.returnMonthsContainerTarget.classList.add("hidden")
      this.returnMonthsFieldTarget.removeAttribute("required")
    }
  }

  showReasonForReturn() {
    if (this.returnTimeSelectTarget.value !== "Sem retorno") {
      this.reasonForReturnContainerTarget.classList.remove("hidden")
    } else {
      this.reasonForReturnContainerTarget.classList.add("hidden")
    }
  }

  changeReturnTimeDivSize() {
    if(this.returnTimeSelectTarget.value === "Outro") {
      this.indicationContainerTarget.parentElement.classList.add("appointment-extra-fields--return-other");
    } else {
      this.indicationContainerTarget.parentElement.classList.remove("appointment-extra-fields--return-other");
    }
  }
  validateReturnMonthsField() {
    if(this.returnMonthsFieldTarget.value != ""){
      if(this.returnMonthsFieldTarget.value < 1) {
        this.returnMonthsFieldTarget.value = 1;
      }
      if(this.returnMonthsFieldTarget.value > 99) {
        this.returnMonthsFieldTarget.value = 99;
      }
    }
  }
}
